import { appliedFiltersSidebarAtom } from '@pages/VendorsSearch/containers/FilterPills/components/Sidebar/atoms';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';

export const useAppliedFilterCount = () => {
	const appliedFiltersSidebar = useAtomValue(appliedFiltersSidebarAtom);

	return useMemo(
		() =>
			appliedFiltersSidebar.reduce((acc, appliedSidebarFilter) => {
				return acc + appliedSidebarFilter.calculateCount();
			}, 0),
		[appliedFiltersSidebar],
	);
};
